import {AbstractUI} from "./AbstractUI"
import bidello,{component} from "bidello";

export class Loader extends component(AbstractUI){



    init(){

        this.loaderElement = this.domElement.querySelector(" .chrome");
        this.bindEvents ()

    }

    setPercentLoaded(percentage){

        this.loaderElement.style.strokeDashoffset = `${628-(628*percentage)}px`

    }


    hideLoader (){

        this.domElement.classList.remove ("active");
        this.domElement.classList.remove ("free");

    }

    showLoader (){

        this.domElement.classList.add ("active");

    }

    collectChildren (){



    }




}